export const SHARED_TRANSLATION_DOMAINS = [
  'analysis-steps-button',
  'ai',
  'app-rating',
  'analyze-list',
  'analyze-parameter',
  'analyze-parameters',
  'aplication',
  'auth',
  'chlorine-real-price',
  'confirmation-modal',
  'date-time-picker',
  'default-products',
  'delete-account-modal',
  'equipment-status',
  'form-validation',
  'info-popover',
  'img',
  'local-creation',
  'lead',
  'limit-modal',
  'local-info-header',
  'necessary-products-confirmation',
  'notification-status',
  'notification-type',
  'piscinapp-select',
  'phone-form',
  'place-card',
  'pool-card',
  'pool-form-card',
  'pool-registration',
  'pool-sign',
  'popover',
  'preferences',
  'product-card',
  'product-keyboard',
  'products',
  'products-settings',
  'report-link',
  'rule-filter',
  'select-modal',
  'special-treatment-flow',
  'synchronization',
  'suport-chat',
  'support-tickets',
  'terms-of-use',
  'unit-of-measurement',
  'water-type',
];
